import { LeftArrowIcon, RightArrowIcon } from '@/assets/icons';
import IconButton from '@/components/common/IconButton';
import { SECTION_SLOGANS, SECTION_TITLES } from '@/constants/products';
import useMainReviewProductsQuery from '@/hooks/RQHooks/market/review/useMainReviewProductsQuery';
import { useViewportStore } from '@/store/useViewportStore';
import Autoplay from 'embla-carousel-autoplay';
import useEmblaCarousel from 'embla-carousel-react';
import { debounce } from 'lodash';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import FeaturedSectionSkeleton from '../../../../components/common/FeaturedSectionSkeleton';
import ReviewCard from '../cards/ReviewCard';
import SectionTitle from './SectionTitle';

const ReviewCarousel = () => {
  const { data, isPending } = useMainReviewProductsQuery();
  const isMobile = useViewportStore((store) => store.isMobile);
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true }, [
    Autoplay({ delay: 5000, stopOnInteraction: false }),
  ]);

  const [curSlideIndex, setCurSlideIndex] = useState(0);

  const debouncedSetIndex = debounce((index) => {
    setCurSlideIndex(index);
  }, 100); // 100ms 딜레이

  const handleLeftClick = () => {
    if (curSlideIndex === 0 && data) {
      emblaApi?.scrollTo(data.length - 1);
    }
    emblaApi?.scrollTo(curSlideIndex - 1);
  };

  const handleRightClick = () => {
    if (data && curSlideIndex === data.length - 1) {
      emblaApi?.scrollTo(0);
    }
    emblaApi?.scrollTo(curSlideIndex + 1);
  };

  useEffect(() => {
    if (emblaApi) {
      emblaApi.on('select', () => {
        debouncedSetIndex(emblaApi.selectedScrollSnap());
      });
    }
  }, [emblaApi, debouncedSetIndex]);

  return (
    <div>
      <SectionTitle title={SECTION_TITLES.REVIEWS} slogan={SECTION_SLOGANS.REVIEWS} />
      {isPending ? (
        <FeaturedSectionSkeleton />
      ) : (
        (data ?? []).length > 0 && (
          <CarouselLayout>
            {!isMobile && (
              <BtnPositionWrapper>
                <IconButton onClick={handleLeftClick}>
                  <LeftArrow width={16} height={16} />
                </IconButton>
              </BtnPositionWrapper>
            )}
            <EmblaCarouselOutWrapper ref={emblaRef}>
              <EmblaCarouselContainer>
                {data?.map((item, index) => (
                  <EmblaSlide key={index}>
                    <ProductGrid>
                      {item.map((p) => (
                        <ReviewCard key={p.id} {...p} />
                      ))}
                    </ProductGrid>
                  </EmblaSlide>
                ))}
              </EmblaCarouselContainer>
            </EmblaCarouselOutWrapper>
            {!isMobile && (
              <BtnPositionWrapper>
                <IconButton onClick={handleRightClick}>
                  <RightArrow width={16} height={16} />
                </IconButton>
              </BtnPositionWrapper>
            )}
          </CarouselLayout>
        )
      )}
    </div>
  );
};

export default ReviewCarousel;

const CarouselLayout = styled.div`
  display: flex;
`;

const EmblaCarouselOutWrapper = styled.div`
  overflow: hidden;
`;
const EmblaCarouselContainer = styled.div`
  display: flex;
  width: 100vw;
`;
const EmblaSlide = styled.div`
  flex: 0 0 100%;
  min-width: 0;
  padding: 10px;
`;

const ProductGrid = styled.div`
  display: flex;
  gap: 16px;
`;

const BtnPositionWrapper = styled.div`
  height: full;
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LeftArrow = styled(LeftArrowIcon)``;

const RightArrow = styled(RightArrowIcon)``;
